import {ActionDemo} from './ActionDemo';
export default ActionDemo;
